import api from './api';
import { Agreement, AgreementForm, AgreementList, AgreementToServiceRel } from '../types';

export type { Agreement, AgreementForm, AgreementList, AgreementToServiceRel } from '../types';

export const agreementsApi = {
  // Получить все договоры
  async getAgreements(search?: string): Promise<AgreementList[]> {
    const params = search ? { search } : {};
    const response = await api.get('/api/agreements', { params });
    return response.data;
  },

  // Получить договор по ID
  async getAgreement(id: number): Promise<Agreement> {
    const response = await api.get(`/api/agreements/${id}`);
    return response.data;
  },

  // Получить договоры компании
  async getAgreementsByCompany(companyId: number): Promise<AgreementList[]> {
    const response = await api.get(`/api/agreements/company/${companyId}`);
    return response.data;
  },

  // Создать договор
  async createAgreement(agreement: AgreementForm): Promise<Agreement> {
    const response = await api.post('/api/agreements', agreement);
    return response.data;
  },

  // Обновить договор
  async updateAgreement(id: number, agreement: Partial<AgreementForm>): Promise<Agreement> {
    const response = await api.put(`/api/agreements/${id}`, agreement);
    return response.data;
  },


  // Получить связи договора с услугами
  async getAgreementServiceRelations(agreementId: number): Promise<AgreementToServiceRel[]> {
    const response = await api.get(`/api/agreement-to-service-rel/agreement/${agreementId}`);
    return response.data;
  },

  // Создать связь договора с услугой
  async createAgreementServiceRelation(relation: {
    agreement_id: number;
    service_id: number;
    price: number;
    rel_type: '1' | '2' | '3' | '4' | '5';
  }): Promise<AgreementToServiceRel> {
    const response = await api.post('/api/agreement-to-service-rel/', relation);
    return response.data;
  },

  // Обновить связь договора с услугой (только active — вкл/выкл услуги в договоре)
  async updateAgreementServiceRelation(id: number, relation: {
    active?: boolean;
    price?: number;
    rel_type?: '1' | '2' | '3' | '4' | '5';
  }): Promise<AgreementToServiceRel> {
    const response = await api.put(`/api/agreement-to-service-rel/${id}`, relation);
    return response.data;
  },

  // Удалить связь договора с услугой
  async deleteAgreementServiceRelation(id: number): Promise<void> {
    await api.delete(`/api/agreement-to-service-rel/${id}`);
  },
};


























